import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Container,
  Typography,
  ListItemIcon,
  MenuItem,
  Fab,
  Grid,
  Button,
} from "@mui/material";
import Box from "@mui/material/Box";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Delete } from "@mui/icons-material";
import PropaneIcon from "@mui/icons-material/Propane";
import CircularProgress from "@mui/material/CircularProgress";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import DetallePedido from "../../pedidos/DetallePedido";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import { useNavigate } from "react-router-dom";
import EvStationIcon from "@mui/icons-material/EvStation";
import Title from "../../../Title";
import { Tooltip } from "@mui/material";
import AddPedidos4 from "../pedidos/altapedido/AddPedidos4";
import moment from "moment";
import AddPedidosList from "../pedidos/altapedido/AddPedidosList";
import EstadisticaPedidos from "./EstadisticaPedidos";
import AddpedidosList_definitivo from "../pedidos/altapedido/AddpedidosList_definitivo";


function Pedidos(props) {
  let navigate = useNavigate();
  const [dataCliente, setDataCliente] = useState(props.datos);
  const [pedidos, setPedidos] = useState(null); // Acá me trigo los pedidos que existen
  const [tabla, setTabla] = useState(true);
  const [alta, setAlta] = useState(false); // para manejar el alta del pedido
  const [openModal, setopenModal] = useState(false);
  const [bgColorTableHeadCell, setBgColorTableHeadCell] = useState(
    props.soloLectura ? "#566573" : "#1F618D",
  );

  //Funcion para obtener pedidos
  const obtenerPedidos = () => {
    fetch(UrlApi + "/pedidos/idcliente/" + dataCliente.id)
      .then((data) => data.json())
      .then((data) => setPedidos(data));
  };

  useEffect(() => {
    obtenerPedidos();
  }, [tabla]);

  const handleOpenModal = (data) => {
    setopenModal(true);
  };

  const columns = useMemo(
    () => [
      {
        header: " Datos Pedido",
        columns: [
          {
            accessorKey: "id", //access nested data with dot notation
            header: "#",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 10,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                maxWidth: 10,
              },
            }),
          },
          {
            accessorKey: "localidad_direccionentrega", //access nested data with dot notation
            header: "Localidad Domicilio",
            enableColumnActions: false,
            enableColumnFilter: false,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                width: "100px",
                maxWidth: "100px",
              },
            }),
            Cell: ({ row }) => (
              <Tooltip title={row.original.localidad_direccionentrega}>
                <span>{row.original.localidad_direccionentrega}</span>
              </Tooltip>
            ),
          },
          {
            accessorKey: "nombre_direccion",
            header: "Punto de entrega",
            enableColumnActions: false,
            maxSize: 5,
            accessorFn: (d) => `${d.nombre_direccion} (${d.direccion})`,
          },
          {
            accessorFn: (reg) => moment(reg.registrado).format("DD-MM-YYYY"),
            header: "Registrado",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 10,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
              },
            }),
          },
          {
            accessorKey: "sucursal_atiende",
            header: "Sucursal Atiende",
            enableColumnActions: false,
            maxSize: 5,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
              },
            }),
          },
          // {
          //   accessorKey: "empresa",
          //   header: "Empresa",
          //   enableColumnActions: false,
          //   enableColumnFilter: false,
          //   size: 10,
          //   muiTableBodyCellProps: ({ row }) => ({
          //     sx: {
          //       backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
          //       color: "black",
          //     },
          //   }),
          // },
          {
            accessorKey: "estado",
            header: "Estado",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 20,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                width: "20px",
                maxWidth: "20px",
              },
            }),
            Cell: ({ row }) => (
              <Tooltip title={row.original.valor} arrow>
                <span>{row.original.estado}</span>
              </Tooltip>
            ),
          },
        ],
      },
      {
        header: "Datos Entrega",
        muiTableHeadCellProps: {
          sx: {
            borderLeft: 1,
            borderRight: 1,
            borderColor: "#fff",
            backgroundColor: bgColorTableHeadCell,
            color: "white", // Color del texto
            fontSize: 16,
            fontWeight: "normal",
            pt: 1,
          },
        },
        columns: [
          {
            accessorKey: "kgentregados",
            header: "Kgs",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 5,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                width: "20px",
                maxWidth: "20px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }),
            muiTableHeadCellProps: {
              sx: {
                fontSize: 16,
                fontWeight: "normal",
                pt: 1,
                backgroundColor: bgColorTableHeadCell,
                borderLeft: 1,
                borderRight: 1,
                borderColor: "#fff",
                color: "white", 
              },
            },
          },
          {
            accessorKey: "ltsentregados",
            header: "Lts",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 5,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                width: "20px",
                maxWidth: "20px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }),
            muiTableHeadCellProps: {
              sx: {
                fontSize: 16,
                fontWeight: "normal",
                pt: 1,
                borderRight: 1,
                backgroundColor: bgColorTableHeadCell,
                color: "white", // Puedes ajustar el color del texto también
              },
            },
          },
          {
            accessorKey: "fecha_real_entrega",
            header: "Entregado",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 5,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                width: "20px",
                maxWidth: "20px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }),
            muiTableHeadCellProps: {
              sx: {
                fontSize: 16,
                fontWeight: "normal",
                pt: 1,
                borderRight: 1,
                backgroundColor: bgColorTableHeadCell,
                color: "white", // Puedes ajustar el color del texto también
              },
            },
          },
          {
            accessorKey: "nro_remito",
            header: "Remito",
            enableColumnActions: false,
            enableColumnFilter: false,
            size: 5,
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                color: "black",
                width: "20px",
                maxWidth: "20px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }),
            muiTableHeadCellProps: {
              sx: {
                fontSize: 16,
                fontWeight: "normal",
                pt: 1,
                borderRight: 1,
                backgroundColor: bgColorTableHeadCell,
                color: "white", // Puedes ajustar el color del texto también
              },
            },
          },
        ],
      },
    ],
    [],
  );

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //larger tooltip font size
              },
            },
          },
        },
      }),
    [globalTheme],
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageSize: 10,
      pageIndex: 0,
    },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: bgColorTableHeadCell,
      pt: 1,
    },
  };

  const rowBg = {
    // 19: "#FFFFFF",
    19: "#F5CBA7", //Lo voy a poner en amarillo
    21: "#ABEBC6", //aprobado -> verde clarito
    22: "#EC7063", //rechazado -> rojo
    23: "#85C1E9", //asignado -> celestito
    24: "#138D75", //entregado
    25: "#D7BDE2", //Facturado -> violeta
    40: "#D6DBDF",
    41: "#EC7063", //CANCELADO -> BORDÓ
    243: "#f29696", //ERROR DE FACTURACION
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  // console.log("props en tabvla pedidos", props);

  return (
    <div>
      {alta && (
        <Button
          variant="outlined"
          onClick={() => {
            setAlta(false);
            setTabla(true);
          }}
          color="error"
        >
          Volver
        </Button>
      )}
      {/* <Button variant="text" size="small" sx={{ color: "black" }} onClick={handleOpenModal}>*/}

      {tabla && pedidos ? (
        <>
          <Box boxShadow={3} mb={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                // enableTopToolbar={false}
                enableRowActions={false}
                enableHiding={false}
                enablePinning={false}
                enableTopToolbar={true}
                showGlobalFilter={false}
                enableDensityToggle={false}
                enableColumnResizing={false}
                enableExpandAll={false}
                columns={columns}
                data={pedidos}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                initialState={initialState}
                muiTableHeadCellProps={tableHeadCellProps}
                localization={MRT_Localization_ES}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
                    color: "black",
                  },
                })}
                renderDetailPanel={({ row }) => (
                  <DetallePedido datos={row.original} />
                )}
                enableColumnActions={false}
                enableColumnFilters={false}
              />
            </ThemeProvider>
          </Box>

          {!props.soloLectura && (
            <>
              <Box
                sx={{
                  position: "fixed",
                  bottom: 35,
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: 2, // Espacio entre los botones
                  zIndex: 10,
                }}
              >
                <Fab
                  variant="extended"
                  color="secondary"
                  aria-label="add"
                  onClick={handleOpenModal}
                >
                  <LeaderboardIcon sx={{ mr: 1 }} /> Estadísticas
                </Fab>
                <Fab
                  disabled={!props.permisos.find(permiso=>permiso.funcion == "cargar_pedidos")}
                  variant="extended"
                  color="primary"
                  aria-label="add"
                  onClick={() => {
                    setAlta(true);
                    setTabla(false);
                  }}
                >
                  <EvStationIcon sx={{ mr: 1 }} /> Cargar Pedido
                </Fab>
              </Box>
            </>
          )}
        </>
      ) : null}

      {/**en prod esta como AddpedidosList_definitivo !== a AddPedidosList */}
      {alta ? (
        <AddPedidosList
          datosCli={dataCliente}
          addPedido={setAlta}
          tabla={setTabla}
          tabs={props.tabs}
          setDataCliente={setDataCliente}
          vengo={"PedidosCli"}
        />
      ) : null}

      {openModal ? (
        <EstadisticaPedidos
          open={openModal}
          setopen={setopenModal}
          dataCliente={dataCliente}
        />
      ) : null}
    </div>
  );
}

export default Pedidos;
{
  /* <MaterialReactTable
                localization={MRT_Localization_ES}
                enableTopToolbar={false}
                enablePagination={true}
                columns={columns}
                data={pedidos}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning
                initialState={initialState}
                enableRowSelection={false}
                positionToolbarAlertBanner="bottom"
                positionActionsColumn="last"
                enableHiding={false}
                muiTableHeadCellProps={tableHeadCellProps}
                positionExpandColumn="first"
                renderDetailPanel={({ row }) => (
                  <DetallePedido datos={row.original} />
                )}
                enableExpandAll={false}
                muiTableBodyCellProps={({ row }) => ({
                  align: "center",
                  sx: {
                    backgroundColor: "#ffffff",
                    color: "black",
                    borderColor: "#FDFEFE",
                  },
                })}
                enableColumnActions={false}
                enableColumnFilters={false} //Quita filtros por columna
                displayColumnDefOptions={displayColumnDefOptions}
                enableDensityToggle={false}
                enableBottomToolbar={false}
              /> */
} // console.log(pedidos)
// const columns = useMemo(
//   () => [
//       {
//         accessorKey: "id", //access nested data with dot notation
//         header: "N°",
//         size: 10,
//       },
//       {
//         header: "Datos Entrega",
//         muiTableHeadCellProps: {
//           sx: {
//             borderLeft: 1,
//             borderRight: 1,
//             borderColor: "#fff",
//             backgroundColor: "#2471A3",
//             color: "white", // Color del texto
//             fontSize: 16,
//             fontWeight: "normal",
//             pt: 1,
//           },
//         },
//         columns: [
//           {
//             accessorKey: "kgentregados",
//             header: "Kgs",
//             enableColumnActions: false,
//             enableColumnFilter: false,
//             size: 5,
//             muiTableBodyCellProps: ({ row }) => ({
//               sx: {
//                 backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
//                 color: "black",
//                 width: "20px",
//                 maxWidth: "20px",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               },
//             }),
//             muiTableHeadCellProps: {
//               sx: {
//                 fontSize: 16,
//                 fontWeight: "normal",
//                 pt: 1,
//                 backgroundColor: "#2471A3",
//                 borderLeft: 1,
//                 borderRight: 1,
//                 borderColor: "#fff",
//                 color: "white", // Puedes ajustar el color del texto también
//               },
//             },
//           },
//           {
//             accessorKey: "ltsentregados",
//             header: "Lts",
//             enableColumnActions: false,
//             enableColumnFilter: false,
//             size: 5,
//             muiTableBodyCellProps: ({ row }) => ({
//               sx: {
//                 backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
//                 color: "black",
//                 width: "20px",
//                 maxWidth: "20px",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               },
//             }),
//             muiTableHeadCellProps: {
//               sx: {
//                 fontSize: 16,
//                 fontWeight: "normal",
//                 pt: 1,
//                 borderRight: 1,
//                 backgroundColor: "#2471A3",
//                 color: "white", // Puedes ajustar el color del texto también
//               },
//             },
//           },
//           {
//             accessorKey: "fecha_real_entrega",
//             header: "Entregado",
//             enableColumnActions: false,
//             enableColumnFilter: false,
//             size: 5,
//             muiTableBodyCellProps: ({ row }) => ({
//               sx: {
//                 backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
//                 color: "black",
//                 width: "20px",
//                 maxWidth: "20px",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               },
//             }),
//             muiTableHeadCellProps: {
//               sx: {
//                 fontSize: 16,
//                 fontWeight: "normal",
//                 pt: 1,
//                 borderRight: 1,
//                 backgroundColor: "#2471A3",
//                 color: "white", // Puedes ajustar el color del texto también
//               },
//             },
//           },

//         ],
//       },
//     ],
//     []
//   );

//   const globalTheme = useTheme();
//   const tableTheme = useMemo(
//     () =>
//       createTheme({
//         palette: {
//           mode: globalTheme.palette.mode,
//           primary: globalTheme.palette.primary, //primary color for the table
//           info: {
//             main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
//           },
//           background: {
//             default:
//               globalTheme.palette.mode === "light"
//                 ? "rgb(234, 239, 241)"
//                 : "#000", //pure black table in dark mode for fun
//           },
//         },
//         typography: {
//           button: {
//             textTransform: "none", //customize typography styles for all buttons in table by default
//             fontSize: "1rem",
//           },
//         },
//         components: {
//           MuiTooltip: {
//             styleOverrides: {
//               tooltip: {
//                 fontSize: "0.8rem", //larger tooltip font size
//               },
//             },
//           },
//         },
//       }),
//     [globalTheme]
//   );

//   const initialState = {
//     density: "compact",
//     showGlobalFilter: true,
//     pagination: {
//       pageSize: 10,
//       pageIndex: 0,
//     },
//   };

//   const tableHeadCellProps = {
//     align: "left",
//     sx: {
//       fontSize: 16,
//       color: "white",
//       fontWeight: "normal",
//       backgroundColor: "#2471A3",
//       pt: 1,
//     },
//   };

//   const rowBg = {
//     // 19: "#FFFFFF",
//     19: "#F5CBA7", //Lo voy a poner en amarillo
//     21: "#ABEBC6", //aprobado -> verde clarito
//     22: "#EC7063", //rechazado -> rojo
//     23: "#85C1E9", //asignado -> celestito
//     24: "#138D75", //entregado
//     25: "#D7BDE2", //Facturado -> violeta
//     40: "#D6DBDF",
//     41: "#EC7063", //CANCELADO -> BORDÓ
//     243: "#f29696" //ERROR DE FACTURACION
//   };

//   // console.log("props en tabvla pedidos", props);

//   return (
//     <div>
//       {alta && (
//         <Button
//           variant="outlined"
//           onClick={() => {
//             setAlta(false);
//             setTabla(true);
//           }}
//           color="error"
//         >
//           Volver
//         </Button>
//       )}
// <<<<<<< HEAD

// =======
//       <Button variant="text" size="small" sx={{ color: "black" }} onClick={handleOpenModal}>
//         ESTADISTICA
//       </Button>
// >>>>>>> 55f649dcb84ac06351f820761efd6814ecc1de6f
//       {tabla && pedidos ? (
//         <>
//           <Box boxShadow={3} mb={3}>
//             <ThemeProvider theme={tableTheme}>
//               <MaterialReactTable
//                 enableTopToolbar={false}
//                 enableRowActions={false}
//                 enableHiding={false}
//                 enablePinning={false}
//                 showGlobalFilter={false}
//                 enableDensityToggle={false}
//                 enableColumnResizing={false}
//                 enableExpandAll={false}
//                 columns={columns}
//                 data={pedidos}
//                 initialState={initialState}
//                 muiTableHeadCellProps={tableHeadCellProps}
//                 localization={MRT_Localization_ES}
//                 muiTableBodyCellProps={({ row }) => ({
//                   align: "left",
//                   sx: {
//                     backgroundColor: rowBg[row.original.id_estado] ?? "#fff",
//                     color: "black",
//                   },
//                 })}
//                 renderDetailPanel={({ row }) => (
//                   <DetallePedido datos={row.original} />
//                 )}
//                 enableColumnActions={false}
//                 enableColumnFilters={false}
//               />
//             </ThemeProvider>
//           </Box>

//           {/* Botón flotante fuera del Box para evitar restricciones */}
// <<<<<<< HEAD
//           {!props.soloLectura && (
//             <Fab
//               variant="extended"
//               color="primary"
//               aria-label="add"
//               onClick={() => {
//                 setAlta(true);
//                 setTabla(false);
//               }}
//               sx={{
//                 position: "fixed",
//                 bottom: 35,
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 zIndex: 10,
//               }}
//             >
//               <EvStationIcon sx={{ mr: 1 }} /> Cargar Pedido
//             </Fab>
//           )}
//         </>
//       ) : null}

// =======
//           <Fab
//             variant="extended"
//             color="primary"
//             aria-label="add"
//             onClick={() => {
//               setAlta(true);
//               setTabla(false);
//             }}
//             sx={{
//               position: "fixed",
//               bottom: 35,
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 10,
//             }}
//           >
//             <EvStationIcon sx={{ mr: 1 }} /> Cargar Pedido
//           </Fab>
//         </>
//       ) : null}

// >>>>>>> 55f649dcb84ac06351f820761efd6814ecc1de6f
//       {alta ? (
//         <AddPedidosList
//           datosCli={dataCliente}
//           addPedido={setAlta}
//           tabla={setTabla}
//           tabs={props.tabs}
//           setDataCliente={setDataCliente}
//           vengo={"PedidosCli"}
//         />
//       ) : null}
// <<<<<<< HEAD
//     </div>
// =======

//       {
//         openModal ?
//           <EstadisticaPedidos
//             open={openModal}
//             setopen={setopenModal}
//             dataCliente={dataCliente} />
//           : null
//       }
//     </div>

// >>>>>>> 55f649dcb84ac06351f820761efd6814ecc1de6f
//   );
// }

// export default Pedidos;
// {/* <MaterialReactTable
//                 localization={MRT_Localization_ES}
//                 enableTopToolbar={false}
//                 enablePagination={true}
//                 columns={columns}
//                 data={pedidos}
//                 enableColumnFilterModes={false}
//                 enableColumnOrdering={false}
//                 enableGrouping={false}
//                 enablePinning
//                 initialState={initialState}
//                 enableRowSelection={false}
//                 positionToolbarAlertBanner="bottom"
//                 positionActionsColumn="last"
//                 enableHiding={false}
//                 muiTableHeadCellProps={tableHeadCellProps}
//                 positionExpandColumn="first"
//                 renderDetailPanel={({ row }) => (
//                   <DetallePedido datos={row.original} />
//                 )}
//                 enableExpandAll={false}
//                 muiTableBodyCellProps={({ row }) => ({
//                   align: "center",
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     color: "black",
//                     borderColor: "#FDFEFE",
//                   },
//                 })}
//                 enableColumnActions={false}
//                 enableColumnFilters={false} //Quita filtros por columna
//                 displayColumnDefOptions={displayColumnDefOptions}
//                 enableDensityToggle={false}
//                 enableBottomToolbar={false}
//               /> */}// console.log(pedidos)
// // const columns = useMemo(
// //   () => [
// //       {
// //         accessorKey: "id", //access nested data with dot notation
// //         header: "N°",
// //         size: 10,
// //       },
// //       {
// //         accessorKey: "direccion_entrega", //access nested data with dot notation
// //         header: "Dirección ",
// //         size: 300,
// //       },
// //       {
// //         accessorKey: "kgacargar", //access nested data with dot notation
// //         header: "Pedido(KG)",
// //         size: 90,
// //       },
// //       {
// //         accessorKey: "kgentregados", //access nested data with dot notation
// //         header: "Kg Entregados",
// //         size: 90,
// //       },
// //       {
// //         accessorKey: "ltsentregados", //access nested data with dot notation
// //         header: "Lts Entregados",
// //         size: 90,
// //       },
// //       {
// //         accessorKey: "fecha_requerida_formateada", //access nested data with dot notation
// //         header: "Fecha Requerida",
// //         size: 120,
// //       },
// //       {
// //         accessorKey: "sucursal_atiende", //access nested data with dot notation
// //         header: "Sucursal",
// //         size: 80,
// //       },
// //       {
// //         accessorKey: "empresa", //access nested data with dot notation
// //         header: "Empresa",
// //         size: 80,
// //       },
// //       {
// //         accessorKey: "estado", //access nested data with dot notation
// //         header: "Estado",
// //         size: 70,
// //       },

//   ],
//   []
// );
